/* Joyeux Marché — animations et messages datés. Sans dépendance. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;

  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function sget(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  /* Date de Paris (+ simulateur ?jm_date= hors thème en ligne) */
  function parisNow() {
    var sim = null;
    try {
      var isPreview = (window.Shopify && Shopify.theme && Shopify.theme.role !== 'main') || (window.Shopify && Shopify.designMode);
      if (isPreview) sim = new URLSearchParams(location.search).get('jm_date');
      if (isPreview && sim) sset('jm_date', sim); else if (isPreview) sim = sget('jm_date');
    } catch (e) {}
    if (sim && /^\d{4}-\d{2}-\d{2}$/.test(sim)) return { y: +sim.slice(0, 4), m: +sim.slice(5, 7), d: +sim.slice(8, 10), h: 12, sim: true };
    var parts = {};
    try {
      new Intl.DateTimeFormat('fr-FR', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false })
        .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
      return { y: +parts.year, m: +parts.month, d: +parts.day, h: +parts.hour % 24 };
    } catch (e) { var n = new Date(); return { y: n.getFullYear(), m: n.getMonth() + 1, d: n.getDate(), h: n.getHours() }; }
  }
  var NOW = parisNow();
  function key(y, m, dd) { return y * 10000 + m * 100 + dd; }
  var TODAY = key(NOW.y, NOW.m, NOW.d);
  window.JM = { now: NOW, today: TODAY };

  /* Préférences animations */
  var mq = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function reduced() { return mq.matches || get('jm_motion') === 'reduced'; }
  function snowOn() { return !reduced() && get('jm_snow') !== 'off'; }
  function applyClasses() {
    root.classList.toggle('jm-reduced', reduced());
    root.classList.toggle('jm-snow-off', !snowOn());
  }
  applyClasses();

  /* Neige vivante (canvas) : les flocons s'écartent de la souris (ou du doigt), suivent le défilement
     et peuvent être soulevés par la boule à neige du hero (window.JMSnow.gust). */
  var snow = { cv: null, ctx: null, flakes: [], extra: [], raf: 0, running: false, w: 0, h: 0, dpr: 1, last: 0 };
  var ptr = { x: -9999, y: -9999, vx: 0, vy: 0, t: 0, on: false };
  var wind = 0, windTarget = 0, windT = 0, gustWind = 0, lastScroll = 0;
  var R = 95, R2 = R * R;
  /* Horizon fait défiler la page dans .page-wrapper sur ordinateur (dès 990 px), et dans la fenêtre sur mobile */
  var PW;
  function scrollPos() {
    if (PW === undefined) PW = d.querySelector('.page-wrapper');
    return Math.max(window.scrollY || 0, PW ? PW.scrollTop : 0);
  }
  function snowInit() {
    if (snow.cv) return;
    var cv = d.createElement('canvas');
    cv.className = 'jm-snow'; cv.setAttribute('aria-hidden', 'true');
    d.body.appendChild(cv);
    snow.cv = cv; snow.ctx = cv.getContext('2d');
    resize(); addEventListener('resize', resize, { passive: true });
    addEventListener('pointermove', onPtr, { passive: true });
    addEventListener('pointerdown', onTap, { passive: true });
    d.addEventListener('mouseout', function (e) { if (!e.relatedTarget) ptr.on = false; });
  }
  function resize() {
    if (!snow.cv) return;
    /* Taille lue sur le canvas lui-même (100vw × 100vh) : sur mobile, la barre d'adresse qui apparaît
       ou disparaît ne déforme plus les flocons et ne les fait plus repartir du haut. */
    var b = snow.cv.getBoundingClientRect(), w = Math.round(b.width) || innerWidth, h = Math.round(b.height) || innerHeight;
    var widthChanged = w !== snow.w;
    if (w === snow.w && h === snow.h && snow.flakes.length) return;
    snow.dpr = Math.min(window.devicePixelRatio || 1, 2);
    snow.w = w; snow.h = h;
    snow.cv.width = w * snow.dpr; snow.cv.height = h * snow.dpr;
    snow.ctx.setTransform(snow.dpr, 0, 0, snow.dpr, 0, 0);
    if (widthChanged || !snow.flakes.length) {
      var n = Math.round((w < 750 ? 40 : 80) * density());
      snow.flakes = [];
      for (var i = 0; i < n; i++) snow.flakes.push(flake(true));
    }
  }
  /* Plus Noël approche, plus il neige : environ moitié moins de flocons fin octobre, le maximum les 24 et 25 décembre */
  function density() {
    var m = NOW.m, dd = NOW.d;
    if (m === 12) return dd === 24 || dd === 25 ? 1.3 : dd < 24 ? 0.8 + 0.2 * (dd - 1) / 22 : 1;
    if (m === 11) return 0.55 + 0.25 * (dd - 1) / 29;
    if (m === 1) return dd <= 15 ? 0.75 : 0.6;
    return 0.5;
  }
  function flake(any) {
    var r = 1 + Math.random() * 2.6;
    return { x: Math.random() * snow.w, y: any ? Math.random() * snow.h : -10, r: r, s: 0.35 + Math.random() * 0.9, o: Math.random() * Math.PI * 2, a: 0.5 + Math.random() * 0.45, vx: 0, vy: 0, z: r / 3.6 };
  }
  function onPtr(e) {
    if (e.pointerType === 'touch') return;
    var now = performance.now();
    if (ptr.on && now - ptr.t < 120) {
      ptr.vx = Math.max(-40, Math.min(40, ptr.vx * 0.5 + (e.clientX - ptr.x) * 0.5));
      ptr.vy = Math.max(-40, Math.min(40, ptr.vy * 0.5 + (e.clientY - ptr.y) * 0.5));
    } else { ptr.vx = 0; ptr.vy = 0; }
    ptr.x = e.clientX; ptr.y = e.clientY; ptr.t = now; ptr.on = true;
  }
  /* Au doigt : une petite tape écarte les flocons autour du point touché */
  function onTap(e) {
    if (e.pointerType !== 'touch' || !snow.running) return;
    impulse(e.clientX, e.clientY, 120, 3.2);
  }
  function impulse(x, y, rad, power) {
    var all = snow.flakes.concat(snow.extra), r2 = rad * rad;
    for (var i = 0; i < all.length; i++) {
      var f = all[i], dx = f.x - x, dy = f.y - y, dd = dx * dx + dy * dy;
      if (dd < r2 && dd > 0.01) { var dist = Math.sqrt(dd), p = (1 - dist / rad) * power; f.vx += dx / dist * p; f.vy += dy / dist * p - p * 0.4; }
    }
  }
  function step(f, k, ds, pOn) {
    f.o += 0.01 * k;
    if (pOn) {
      var dx = f.x - ptr.x, dy = f.y - ptr.y, dd = dx * dx + dy * dy;
      if (dd < R2 && dd > 0.01) {
        var dist = Math.sqrt(dd), p = 1 - dist / R;
        f.vx += (dx / dist * p * 0.55 + ptr.vx * 0.035 * p) * k;
        f.vy += (dy / dist * p * 0.4 + ptr.vy * 0.035 * p) * k;
      }
    }
    var damp = Math.pow(f.ttl ? 0.965 : 0.93, k);
    f.vx *= damp; f.vy *= damp;
    f.y += (f.s + f.vy) * k - ds * 0.25 * f.z;
    f.x += (Math.sin(f.o) * 0.35 + wind * (0.5 + f.z * 0.7) + f.vx) * k;
  }
  function draw(c, f, alpha) {
    c.beginPath(); c.fillStyle = 'rgba(255,255,255,' + alpha + ')'; c.arc(f.x, f.y, f.r, 0, 6.283); c.fill(); c.stroke();
  }
  function frame(t) {
    var c = snow.ctx, k = snow.last ? Math.min(3, (t - snow.last) / 16.7) : 1;
    snow.last = t;
    c.clearRect(0, 0, snow.w, snow.h);
    c.strokeStyle = 'rgba(110,130,150,.35)'; c.lineWidth = .6;
    if (t - windT > 4000) { windT = t; windTarget = (Math.random() - 0.5) * 0.6; }
    gustWind *= Math.pow(0.985, k);
    wind += (windTarget + gustWind - wind) * 0.03 * k;
    var sy = scrollPos(), ds = sy - lastScroll; lastScroll = sy;
    if (ds > 60) ds = 60; else if (ds < -60) ds = -60;
    var pOn = ptr.on && (t - ptr.t < 1500), base = snowOn(), i, f;
    if (base) {
      for (i = 0; i < snow.flakes.length; i++) {
        f = snow.flakes[i];
        step(f, k, ds, pOn);
        if (f.y > snow.h + 6) snow.flakes[i] = f = flake(false);
        else if (f.y < -14) f.y = snow.h + 4;
        if (f.x < -12) f.x = snow.w + 10; else if (f.x > snow.w + 12) f.x = -10;
        draw(c, f, f.a);
      }
    }
    for (i = snow.extra.length - 1; i >= 0; i--) {
      f = snow.extra[i];
      step(f, k, ds, pOn);
      var age = t - f.born, fade = age > f.ttl ? 1 - (age - f.ttl) / 700 : 1;
      if (fade <= 0 || f.y > snow.h + 10) { snow.extra.splice(i, 1); continue; }
      if (f.x < -12) f.x = snow.w + 10; else if (f.x > snow.w + 12) f.x = -10;
      draw(c, f, f.a * fade);
    }
    if (!base && !snow.extra.length) { snowStop(); return; }
    snow.raf = requestAnimationFrame(frame);
  }
  function run() { if (!snow.running && !d.hidden) { snow.running = true; snow.last = 0; lastScroll = scrollPos(); snow.raf = requestAnimationFrame(frame); } }
  function snowStart() { if (!snowOn() || d.hidden) return; snowInit(); run(); }
  function snowStop() { snow.running = false; cancelAnimationFrame(snow.raf); snow.extra = []; if (snow.ctx) snow.ctx.clearRect(0, 0, snow.w, snow.h); }
  d.addEventListener('visibilitychange', function () { d.hidden ? snowStop() : snowStart(); });
  /* Rafale de neige (boule à neige) : fonctionne même si la neige de fond est coupée, jamais en mode réduit */
  window.JMSnow = {
    gust: function (x, y, n, flurry) {
      if (reduced()) return;
      snowInit();
      var room = Math.max(0, 260 - snow.extra.length), m = Math.min(n || 70, room), now = performance.now(), i, r;
      /* Gerbe qui jaillit de la boule */
      for (i = 0; i < m; i++) {
        var a = Math.random() * 6.283, sp = 3 + Math.random() * 9;
        r = 1 + Math.random() * 2.8;
        snow.extra.push({ x: x + (Math.random() - 0.5) * 20, y: y + (Math.random() - 0.5) * 20, r: r, s: 0.45 + Math.random() * 0.9, o: Math.random() * 6.283, a: 0.65 + Math.random() * 0.35, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp - 4.5, z: r / 3.6, born: now, ttl: 3800 + Math.random() * 2600 });
      }
      gustWind = (Math.random() < 0.5 ? -1 : 1) * (1 + Math.random() * 0.8);
      /* Et il neige plus fort sur toute la page pendant quelques secondes */
      var f = Math.min(flurry || 0, Math.max(0, room - m));
      for (i = 0; i < f; i++) {
        r = 1 + Math.random() * 2.6;
        snow.extra.push({ x: Math.random() * snow.w, y: -10 - Math.random() * snow.h * 0.6, r: r, s: 1.1 + Math.random() * 1.4, o: Math.random() * 6.283, a: 0.55 + Math.random() * 0.4, vx: gustWind * Math.random() * 2, vy: 0, z: r / 3.6, born: now, ttl: 5200 + Math.random() * 2500 });
      }
      run();
    },
    puff: function (x, y) { if (snow.running) impulse(x, y, 140, 4); }
  };

  /* Boutons neige / animations + lien Gérer les cookies */
  function syncButtons() {
    d.querySelectorAll('[data-jm-snow-toggle]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(snowOn()));
      var l = b.querySelector('[data-label]'); if (l) l.textContent = snowOn() ? 'Neige : on' : 'Neige : off';
    });
    d.querySelectorAll('[data-jm-motion-toggle]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(!reduced()));
      var l = b.querySelector('[data-label]'); if (l) l.textContent = reduced() ? 'Animations : réduites' : 'Animations : complètes';
    });
  }
  d.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-jm-snow-toggle],[data-jm-motion-toggle],a[href$="#gerer-les-cookies"]') : null;
    if (!t) return;
    if (t.matches('a[href$="#gerer-les-cookies"]')) {
      e.preventDefault();
      try { if (window.privacyBanner && privacyBanner.showPreferences) privacyBanner.showPreferences(); } catch (er) {}
      return;
    }
    if (t.hasAttribute('data-jm-snow-toggle')) set('jm_snow', snowOn() ? 'off' : 'on');
    else set('jm_motion', reduced() ? 'full' : 'reduced');
    applyClasses(); syncButtons(); snowOn() ? snowStart() : snowStop();
  });
  if (mq.addEventListener) mq.addEventListener('change', function () { applyClasses(); syncButtons(); snowOn() ? snowStart() : snowStop(); });

  /* Messages datés */
  function between(a, b) { return TODAY >= a && TODAY <= b; }
  function datedBlocks() {
    d.querySelectorAll('[data-jm-from],[data-jm-to]').forEach(function (el) {
      var f = +(el.getAttribute('data-jm-from') || '0').replace(/-/g, '');
      var to = +(el.getAttribute('data-jm-to') || '99999999').replace(/-/g, '');
      el.hidden = !between(f, to);
    });
    d.querySelectorAll('[data-jm-now-from]').forEach(function (li) {
      var a = +li.getAttribute('data-jm-now-from'), b = +li.getAttribute('data-jm-now-to');
      if (between(a, b)) { li.classList.add('is-now'); li.setAttribute('aria-current', 'date'); }
    });
    var y = NOW.y;
    var msg;
    if (between(key(y, 11, 23), key(y, 11, 30))) msg = 'Black Friday (la semaine des bonnes affaires) : 2 articles achetés, le 3e offert, jusqu\'au lundi 30 novembre à 23 h 59';
    else if (TODAY <= key(y, 11, 29) && NOW.m >= 10) msg = 'Pour Noël, commande de préférence avant le 30 novembre (délais indicatifs) · Livraison offerte dès 65 €';
    else if (between(key(y, 12, 1), key(y, 12, 11))) msg = 'Livraison avant Noël encore possible, mais pas garantie : délais indicatifs de 8 à 18 jours ouvrés';
    else if (between(key(y, 12, 12), key(y, 12, 24))) msg = 'Ta commande arrivera sans doute après Noël. La carte cadeau, elle, arrive tout de suite par e-mail';
    else if (between(key(y, 12, 25), key(y, 12, 31))) msg = 'Joyeuses fêtes !';
    else if (between(key(y, 1, 1), key(y, 1, 10))) msg = 'Bonne année ! Merci pour ta visite au Joyeux Marché';
    if (msg) d.querySelectorAll('[data-jm-announce]').forEach(function (el) { el.textContent = msg; });
    if (between(key(y, 11, 23), key(y, 11, 30))) root.classList.add('jm-bf');
  }

  /* Jours ouvrés et estimation de livraison */
  var HOL = { '11-11': 1, '12-25': 1, '1-1': 1, '5-1': 1, '5-8': 1, '7-14': 1, '8-15': 1, '11-1': 1 };
  function addWorkdays(date, n) {
    var x = new Date(date.getTime());
    while (n > 0) {
      x.setDate(x.getDate() + 1);
      var wd = x.getDay(), k = (x.getMonth() + 1) + '-' + x.getDate();
      if (wd !== 0 && wd !== 6 && !HOL[k]) n--;
    }
    return x;
  }
  var fmt = function (x) { try { return x.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' }); } catch (e) { return x.toDateString(); } };
  function deliveryEstimate() {
    var els = d.querySelectorAll('[data-jm-delivery]'); if (!els.length) return;
    var base = new Date(NOW.y, NOW.m - 1, NOW.d);
    var a = addWorkdays(base, 8), b = addWorkdays(base, 18);
    els.forEach(function (el) { el.textContent = 'Livraison estimée entre le ' + fmt(a) + ' et le ' + fmt(b) + ' (délais indicatifs)'; });
  }

  /* Compte à rebours Noël (en janvier : « Bonne année ! » plutôt que « Noël dans 350 jours ») */
  function countdown() {
    var els = d.querySelectorAll('[data-jm-countdown]'); if (!els.length) return;
    var xmas = new Date(NOW.y, 11, 25), today = new Date(NOW.y, NOW.m - 1, NOW.d);
    var days = Math.round((xmas - today) / 864e5);
    var newYear = NOW.m === 1 && NOW.d <= 15;
    els.forEach(function (el) {
      var txt = newYear ? 'Bonne année !' : days > 1 ? 'Noël dans ' + days + ' jours' : days === 1 ? 'Noël, c\'est demain !' : days === 0 ? 'Joyeux Noël !' : 'Joyeuses fêtes !';
      var n = el.querySelector('[data-num]');
      if (n && days > 1 && !newYear) { n.textContent = days; el.setAttribute('aria-label', txt); } else { el.textContent = txt; el.removeAttribute('aria-label'); }
    });
  }

  /* Ciel du hero selon l'heure */
  function sky() {
    var h = NOW.h, s = h >= 8 && h < 16 ? 'day' : (h >= 16 && h < 18) || (h >= 7 && h < 8) ? 'dusk' : 'night';
    d.querySelectorAll('[data-jm-sky]').forEach(function (el) { el.setAttribute('data-jm-sky', s); });
  }

  /* Apparition au défilement */
  function reveal() {
    var els = d.querySelectorAll('.jm-reveal'); if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduced()) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e, i) { e.style.setProperty('--jm-delay', (i % 6) * 60 + 'ms'); io.observe(e); });
  }

  /* Traîneau (une fois par visite) */
  function sleigh() {
    var s = d.querySelector('.jm-sleigh'); if (!s) return;
    if (reduced() || sget('jm_sleigh')) return;
    sset('jm_sleigh', '1');
    setTimeout(function () { s.classList.add('is-flying'); }, 1200);
  }

  /* Bandeau défilant : bouton pause */
  d.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-jm-marquee-toggle]') : null; if (!b) return;
    var m = b.closest('.jm-marquee'); var p = m.classList.toggle('is-paused');
    b.setAttribute('aria-pressed', String(p)); b.textContent = p ? 'Lecture' : 'Pause';
  });

  /* Barre livraison offerte (traîneau) */
  var THRESHOLD = 6500;
  function freeShip(total) {
    d.querySelectorAll('[data-jm-freeship]').forEach(function (el) {
      var t = typeof total === 'number' ? total : +el.getAttribute('data-total') || 0;
      var pct = Math.min(100, Math.round(t / THRESHOLD * 100));
      el.style.setProperty('--jm-progress', pct + '%');
      var txt = el.querySelector('[data-text]');
      var left = Math.max(0, THRESHOLD - t);
      if (txt) txt.textContent = left > 0 ? 'Plus que ' + (left / 100).toFixed(2).replace('.', ',') + ' € pour la livraison offerte' : 'Livraison offerte en France 🎉';
      if (left === 0) el.classList.add('is-done'); else el.classList.remove('is-done');
    });
  }
  function refreshCart() {
    if (!d.querySelector('[data-jm-freeship]')) return;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) { freeShip(c.total_price); }).catch(function () {});
  }
  /* Le thème Horizon annonce chaque changement du panier par « shopify:cart:lines-update » (avec une promesse) */
  d.addEventListener('shopify:cart:lines-update', function (e) {
    if (e.promise && e.promise.then) e.promise.then(refreshCart, function () {}); else refreshCart();
  });

  /* Ajout au panier : paquet cadeau */
  d.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
    var b = f.querySelector('[type="submit"]'); if (!b || reduced()) return;
    b.classList.add('jm-gift-pop'); setTimeout(function () { b.classList.remove('jm-gift-pop'); }, 1200);
  }, true);

  function init() {
    datedBlocks(); deliveryEstimate(); countdown(); sky(); reveal(); sleigh(); syncButtons(); refreshCart();
    snowStart();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
